import { useEffect, useState } from "react";
import { CallWithAuth } from "../action/apiActions";
import { UNSUBSCRIBE_USER } from "../action/apiPath";
import { Footer } from "../components/Footer";
import Header from "../components/Header";
import { TwoStepAuthenticationComponent } from "../components/pages/twoStepAuthentication";
import Swal from "sweetalert2";
import { FcCancel } from "react-icons/fc";

import withReactContent from "sweetalert2-react-content";
import { errorMessageCreate } from "../util/custom";
import { showToast, ToastContainer } from "../util/toastHelper";
import { useLocation, useNavigate } from "react-router";
import rightArrow from "../assets/img/arrow-right.svg";
import { useDispatch } from "react-redux";
import { logoutAction } from "../redux/action";
import axios from "axios";
import { GET_USER } from "../action/apiPath";

const MySwal = withReactContent(Swal);

export const Unsubscribe = () => {
  window.scrollTo(0, 0);
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();
  const disptach = useDispatch()
  // Accessing the state using useSelector
  //   console.log(loginState);
  // State to manage the enabled/disabled status of Google Authenticator


  // ---------- Page loading time GET_USER API call ----------
  useEffect(() => {
    const fetchUser = async () => {
      const isTokenAvailable = localStorage.getItem("accessToken");

      if (isTokenAvailable) {
        const header = {
          headers: {
            Authorization: `Bearer ${isTokenAvailable}`,
          },
        };

        try {
          const response = await axios.get(GET_USER, header);
          if (response.status === 200 || response.status === 201) {
            console.log("User data:", response.data.data);
            if (response.data.data?.subscription === null) {
              navigate('/subscription');
            } else
              setUserData(response?.data?.data); //
          }
        } catch (error) {
          console.error("Error fetching user:", error);
        }
      }
    };

    fetchUser();
  }, []);



  const handleClick = async () => {
    const result = await MySwal.fire({
      title: "Are you sure you want to unsubscribe from this platform?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, unsubscribe!",
    });

    if (result.isConfirmed) {
      setIsLoading(true);
      const response = await CallWithAuth("DELETE", UNSUBSCRIBE_USER);
      let message = errorMessageCreate(response?.res?.data?.message);

      if (response.res.data && response.res.data.statusCode === 200) {
        showToast("success", message);
        setTimeout(() => {
          localStorage.clear();
          navigate("/");
          disptach(logoutAction())

        }, 1500)

      } else {
        showToast("error", message);
      }
      setIsLoading(false);
    }
  };

  return (
    <>
      <Header />



      {/* === Current Plan Card === */}
      <section className="site_hero flex-auto create_account_block unsubscribe-platform-page">
        <div className="site_container">
          <div className="heading_block">
            <h1>Subscription Platform</h1>
          </div>
          <div className="plan_packages">
            {userData ? (
              <div className="pkg_item gold_plan">
                <span className="tag">Your Current Plan</span>
                <div className="pkg_header">
                  <h5>{userData.subscription.plan_name}</h5>
                  <div className="plan_price">
                    <h6>
                      <sup>Subscription Ends:</sup>
                      <sub>{new Date(userData.subscription.subscription_enddate).toLocaleDateString()}</sub>
                    </h6>
                  </div>
                </div>
                <div className="pkg_body">
                  <span className="txt"></span>
                  <div className="plan_select_check">
                    <button
                      onClick={() => navigate("/subscription")}
                      className="check_ui"
                    >
                      <span> Manage Plan</span>
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <p className="w-100 text-center text-gray-500 text-lg">
                Loading plan details...
              </p>
            )}
          </div>

          {/* === Old unsubscribe warning section === */}
          <div className="unsubscribe-warning-section">
            <div className="btn_block_unsub d-flex justify-content-center">
              <button disabled={isLoading} onClick={handleClick}>
                <span className="icon"><FcCancel/></span>
                Cancel Subscription
                {isLoading && <span className="button-loader-cls"></span>}
              </button>
            </div>
          </div>


        </div>
      </section>



      <ToastContainer />
      <Footer />
    </>
  );

};
